import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-response-timeline__inner" }
const _hoisted_2 = { class: "c-response-timeline__content" }

import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import type {
  ResponseTimelineItemFields,
  ResponseTimelineProps,
} from '@/types/components/ResponseTimeline';
import AdaptiveImage from '@/elements/AdaptiveImage.vue';
import utils from '@/utils';
import type { ScItem } from '@/types/sitecore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResponseTimeline',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-response-timeline'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});
const normalizeImageField = (imageField: any) => {
  const src = imageField?.value?.src;
  if (
    !src ||
    (!src.startsWith('http://') && !src.startsWith('https://') && !src.startsWith('//'))
  ) {
    return imageField;
  }

  const url = new URL(src.startsWith('//') ? `https:${src}` : src);
  return {
    ...imageField,
    value: {
      ...imageField.value,
      src: `${url.pathname}${url.search}${url.hash}`,
    },
  };
};
const normalizeImageItem = (imageItem: any) => {
  if (!imageItem?.fields) return imageItem;

  return {
    ...imageItem,
    fields: {
      ...imageItem.fields,
      desktopImage: normalizeImageField(imageItem.fields.desktopImage),
      mobileImage: normalizeImageField(imageItem.fields.mobileImage),
      tabletImage: normalizeImageField(imageItem.fields.tabletImage),
    },
  };
};
const items = computed<ScItem<ResponseTimelineItemFields>[]>(() =>
  (props.fields?.items ?? []).map((item) => ({
    ...item,
    fields: item.fields
      ? {
          ...item.fields,
          icon: normalizeImageItem(item.fields.icon),
          backgroundImage: normalizeImageItem(item.fields.backgroundImage),
        }
      : item.fields,
  }))
);

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && items.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "",
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [0, 24],
          "tablet-default-grid": [0, 16],
          "mobile-default-grid": [0, 16]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id,
                  class: "c-response-timeline__card"
                }, [
                  (item.fields?.backgroundImage)
                    ? (_openBlock(), _createBlock(AdaptiveImage, {
                        key: 0,
                        class: "c-response-timeline__pattern",
                        field: item.fields.backgroundImage,
                        show: true,
                        "enable-scroll-detection": false,
                        "show-image-redius": false
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, [
                    (item.fields?.icon)
                      ? (_openBlock(), _createBlock(AdaptiveImage, {
                          key: 0,
                          class: "c-response-timeline__icon",
                          field: item.fields.icon,
                          show: true,
                          "enable-scroll-detection": false,
                          "show-image-redius": false
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true),
                    (item.fields?.title?.value)
                      ? (_openBlock(), _createBlock(_unref(RichText), {
                          key: 1,
                          class: "c-response-timeline__title",
                          field: item.fields.title
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true),
                    (item.fields?.description?.value)
                      ? (_openBlock(), _createBlock(_unref(RichText), {
                          key: 2,
                          class: "c-response-timeline__description",
                          field: item.fields.description
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (fields.value.footerText?.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    class: "c-response-timeline__footer",
                    field: fields.value.footerText
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 4))
    : _createCommentVNode("", true)
}
}

})